import React from 'react';
import { ColumnParams } from '../ColumnTemplate';

const ClickableText = (props: ColumnParams) => {
    return (
        <span className="clickable-text" onClick={() => props.action(props.value, props.row)}>
            {props.value}
        </span>
    );
};

export default ClickableText;